import { FormInstance } from 'antd'
import { IRole } from 'app/api/role/model'
import R from 'app/assets/R'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseSpace } from 'app/components/common/BaseSpace'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import { InputPassword } from 'app/components/common/inputs/InputPassword'
import { BaseSelect } from 'app/components/common/selects/BaseSelect'
import { usePagination } from 'app/hook'
import { useGetRoleList } from 'app/react-query/hook/role'
import { PHONE_REGEX, REG_EMAIL } from 'parkway-web-common'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const FormAccountCommon = ({
  isDisableEmail,
  form,
}: {
  isDisableEmail?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: FormInstance<any>
}) => {
  const { t } = useTranslation()
  const { data: dataRole, isLoading: isLoadingRole } = useGetRoleList({
    limit: 1000,
  })

  const { flattenDataList } = usePagination()

  const roles: IRole[] = useMemo(() => {
    return flattenDataList(dataRole)?.data
  }, [dataRole])

  const itemIsDefault = useMemo(() => {
    return roles?.find(itm => itm?.is_default)
  }, [roles])

  return (
    <BaseSpace size={5}>
      <BaseForm.Item
        name={'name'}
        required
        label={t(R.strings.full_name)}
        rules={[
          {
            required: true,
            message: t(R.strings.require_field, {
              field: t(R.strings.full_name),
            }),
          },
        ]}
      >
        <BaseInput placeholder={t(R.strings.enter_full_name)} />
      </BaseForm.Item>
      <BaseForm.Item
        name={'email'}
        required
        label={t(R.strings.email)}
        rules={[
          {
            required: true,
            message: t(R.strings.require_field, {
              field: t(R.strings.email),
            }),
          },
          {
            pattern: REG_EMAIL,
            message: t(R.strings.regex_email),
          },
        ]}
      >
        <BaseInput
          placeholder={t(R.strings.enter_email)}
          disabled={isDisableEmail}
        />
      </BaseForm.Item>
      <BaseForm.Item
        name={'phone'}
        label={t(R.strings.phone)}
        rules={[
          {
            pattern: PHONE_REGEX,
            message: t(R.strings.regex_phone),
          },
        ]}
      >
        <BaseInput placeholder={t(R.strings.enter_phone)} />
      </BaseForm.Item>

      <BaseForm.Item
        name={'roleIds'}
        label={t(R.strings.role)}
        initialValue={itemIsDefault?.id}
      >
        <BaseSelect
          placeholder={t(R.strings.select_role)}
          showSearch
          loading={isLoadingRole}
          mode="multiple"
          maxTagCount={2}
          options={roles?.map(item => ({
            label: `${item?.name ?? ''} ${
              item?.is_default ? '(Mặc định)' : ''
            }`,
            value: item?.id,
          }))}
        />
      </BaseForm.Item>

      {isDisableEmail ? null : (
        <BaseRow gutter={[16, 8]}>
          <BaseCol xl={12}>
            <BaseForm.Item
              label={t(R.strings.password)}
              name="password"
              rules={[
                {
                  required: true,
                  message: t(R.strings.require_field, {
                    field: t(R.strings.password),
                  }),
                },
              ]}
              required
            >
              <InputPassword
                placeholder={t(R.strings.enter_field, {
                  field: t(R.strings.password),
                })}
              />
            </BaseForm.Item>
          </BaseCol>
          <BaseCol xl={12}>
            <BaseForm.Item
              label={t(R.strings.re_password)}
              name="rePassword"
              rules={[
                {
                  required: true,
                  message: t(R.strings.require_field, {
                    field: t(R.strings.re_password),
                  }),
                },
                {
                  validator: (_, value, callback) => {
                    const { getFieldValue } = form

                    if (value && value !== getFieldValue('password')) {
                      callback(t(R.strings.re_password_not_match))
                    } else {
                      callback()
                    }
                  },
                },
              ]}
              required
            >
              <InputPassword placeholder={t(R.strings.re_password)} />
            </BaseForm.Item>
          </BaseCol>
        </BaseRow>
      )}

      <BaseForm.Item name={'isActive'} label={t(R.strings.status)}>
        <BaseSelect
          defaultValue={true}
          placeholder={t(R.strings.please_select_status)}
          options={[
            { label: t(R.strings.active_content), value: true },
            {
              label: t(R.strings.in_active),
              value: false,
            },
          ]}
        />
      </BaseForm.Item>
    </BaseSpace>
  )
}
